// İçerik yönetim sisteminin (zhesap_main_be) adresi. Formların gittiği ana ürün
// API'sinden (lib/api.ts → VITE_API_URL) AYRI bir servistir; ikisi karıştırılmaz.
// Yayın build'inde tanımlı değilse site statik içerikle çalışır (src/content), hiçbir
// istek atılmaz. Geliştirmede (bun run dev) tanımlı değilse yerel backend varsayılır:
// .env.local unutulunca admin'deki değişiklik sitede görünmüyor, sebebi anlaşılmıyordu.
const configured = import.meta.env.VITE_CMS_API_URL;
const devDefault = import.meta.env.DEV ? 'http://localhost:5080' : null;

export const CMS_API_URL =
  typeof configured === 'string' && configured.trim()
    ? configured.trim().replace(/\/+$/, '')
    : devDefault;

/**
 * Public içerik ucunu okur; yanıt zarfından (`{ result }`) veriyi çıkarır.
 * Hata, zaman aşımı ya da yapılandırma yoksa null döner: çağıran taraf statik
 * içerikte kalır, ziyaretçi boş sayfa görmez.
 */
export async function fetchCms<T>(path: string): Promise<T | null> {
  if (!CMS_API_URL) return null;
  try {
    const response = await fetch(`${CMS_API_URL}${path}`, { signal: AbortSignal.timeout(5000) });
    if (!response.ok) return null;
    const body = (await response.json()) as { result?: T };
    return body.result ?? null;
  } catch {
    return null;
  }
}

/**
 * Yalnız CMS'te olan içerik (blog) için: statik yedek yoktur, bu yüzden "kayıt yok" (404) ile
 * "CMS'e ulaşılamadı" ayrı bildirilir. İlki sayfada "bulunamadı", ikincisi "şu an yüklenemedi" olur.
 */
export type CmsResult<T> = { status: 'ok'; data: T } | { status: 'notFound' } | { status: 'unavailable' };

export async function fetchCmsResult<T>(path: string): Promise<CmsResult<T>> {
  if (!CMS_API_URL) return { status: 'unavailable' };
  try {
    const response = await fetch(`${CMS_API_URL}${path}`, { signal: AbortSignal.timeout(5000) });
    if (response.status === 404) return { status: 'notFound' };
    if (!response.ok) return { status: 'unavailable' };
    const body = (await response.json()) as { result?: T };
    return body.result === undefined ? { status: 'unavailable' } : { status: 'ok', data: body.result };
  } catch {
    return { status: 'unavailable' };
  }
}
